/** DOM overlays: boot, unsupported-browser, fatal error and click-to-play. */
function el(id: string): HTMLElement {
  return document.getElementById(id)!;
}

export const screens = {
  /** Loading-screen text, and optionally how far along it is (0–1, approximate). */
  bootStatus(text: string, progress?: number): void {
    el('boot-status').textContent = text;
    if (progress === undefined) return;
    const bar = el('boot-bar');
    bar.classList.remove('waiting');
    (bar.firstElementChild as HTMLElement).style.transform = `scaleX(${Math.min(1, Math.max(0, progress))})`;
  },
  showBoot(): void {
    el('play').classList.add('hidden');
    el('boot').classList.remove('hidden');
  },
  hideBoot(): void {
    el('boot').classList.add('hidden');
  },
  /**
   * The menu over a still picture (no world loaded yet), or over the live world. The still
   * one offers a button to load the menu world instead of "click to enter".
   */
  stillMenu(still: boolean, image?: string): void {
    const backdrop = el('backdrop');
    if (image) backdrop.style.backgroundImage = `url(${image})`;
    backdrop.classList.toggle('hidden', !still);
    el('play').classList.toggle('still', still);
    el('load-menu-world').classList.toggle('hidden', !still);
    el('still-note').classList.toggle('hidden', !still);
    (document.querySelector('#play .brand-tag') as HTMLElement).classList.toggle('hidden', still);
  },
  unsupported(detail?: string): void {
    el('boot').classList.add('hidden');
    el('unsupported').classList.remove('hidden');
    if (detail) el('unsupported-detail').textContent = detail;
  },
  fatal(err: unknown): void {
    el('boot').classList.add('hidden');
    el('play').classList.add('hidden');
    el('fatal').classList.remove('hidden');
    const text = err instanceof Error ? `${err.message}\n\n${err.stack ?? ''}` : String(err);
    el('fatal-text').textContent = text;
    console.error(err);
  },
  /** Show the click-to-play overlay while the pointer isn't locked. */
  setPlaying(playing: boolean): void {
    el('play').classList.toggle('hidden', playing);
    el('crosshair').classList.toggle('hidden', !playing);
    el('hud').classList.toggle('hidden', !playing);
  },
  onPlayClick(handler: () => void): void {
    el('play').addEventListener('click', handler);
  },
  /** Show short hints one after another near the bottom of the screen. */
  hints(lines: string[], seconds = 5): void {
    const box = el('hint');
    let t = 600;
    for (const line of lines) {
      setTimeout(() => {
        box.textContent = line;
        box.classList.add('show');
      }, t);
      t += seconds * 1000;
      setTimeout(() => box.classList.remove('show'), t - 800);
    }
  },
};
